import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { ToastContainer } from 'react-toastify';

import './App.css';
import 'react-toastify/dist/ReactToastify.css';
/* import "react-image-gallery/styles/scss/image-gallery.scss"; */
import "react-image-gallery/styles/css/image-gallery.css";
import Router from './route/Router';
import store from './store';

const persistor = persistStore(store);

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
        <ToastContainer />
      </PersistGate>
    </Provider>
  );
}

export default App;
